var map = {
	"./bankinter.png": "0f46",
	"./icon-mapfre.png": "ca59",
	"./kutxa.png": "a094",
	"./logo-mapfre.png": "b9a0",
	"./logo.png": "4ffd",
	"./mapfre.png": "e11d",
	"./mapfre0.png": "56b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";